import React, { useEffect } from 'react';

import useProducts from 'b2b-ui-components-lib/lib/hooks/useProducts';
import useProfile from 'b2b-ui-components-lib/lib/hooks/useProfile';
import useDataConfig from 'b2b-ui-components-lib/lib/hooks/useDataConfig';
import useNotifications from 'b2b-ui-components-lib/lib/hooks/useNotifications';
import useProfileCompleteness from 'b2b-ui-components-lib/lib/hooks/useProfileCompleteness';
import usePartyAccounts from 'b2b-ui-components-lib/lib/hooks/usePartyAccounts';

import PostLoginHeader from 'b2b-ui-components-lib/lib/components/postLoginHeader';

import ABHeader from 'b2b-ui-components-lib/lib/components/ABheader';
import { findParamFromUrl, getFromSessionStorage, isEDLJourney } from 'common/utils/app.utils';
import { LOB, SERVICE_TYPE } from 'common/constants/app.constants';
import { PROFILE_DATA, MODULE_ID } from 'home/common/constants/constants';

import EDLHeader from './edl-header';

const AppHeader = (props) => {
  const lob = LOB.DATA;
  const partyIdFromUrl = findParamFromUrl('partyId');
  const productType = findParamFromUrl('productType');
  const productName = productType ? SERVICE_TYPE[productType] : SERVICE_TYPE.DEDICATED_INTERNET;

  const { isAuth, profile } = useProfile();
  const { config, fetchConfig } = useDataConfig();
  const {
    // lob,
    lobs,
    lobDetails,
    fetchSelectedLob,
    products,
    fetchProducts,
    fetchPartnerProducts,
    partnerProducts,
    fetchSelectedProduct,
    getLobDetails,
    getProductDetails
  } = useProducts();
  let { partyId, partyDetails, fetchSelectedParty, fetchPartyAccounts, setPartyAccount } = usePartyAccounts();

  const { notifications, markRead, fetchNotifications } = useNotifications({ lob });
  const { profileCompleteness, fetchProfileCompleteness } = useProfileCompleteness();

  useEffect(() => {
    if (isAuth) {
      const userProfile = getFromSessionStorage(MODULE_ID, PROFILE_DATA);
      fetchProducts({ partyId: partyIdFromUrl ? partyIdFromUrl : partyId, userProfileType: userProfile?.profileType });
    }
  }, [isAuth]);

  useEffect(() => {
    if (isAuth) {
      fetchSelectedLob({ lobs, lob });
      fetchSelectedProduct({ products, product: productName });
      const lobDocument = getLobDetails(lob);
      const productDocument = getProductDetails(productName);
      fetchSelectedParty({
        lobDetails: lobDocument,
        product: productDocument && productDocument.productType,
        partyId: partyIdFromUrl
      });
    }
  }, [isAuth, lobs, products]);

  useEffect(() => {
    if (isAuth) {
      fetchProfileCompleteness({ partyId });
      fetchNotifications({ lob, partyId });
      fetchPartnerProducts({ partyId });
    }
  }, [isAuth, partyDetails]);

  useEffect(() => {
    if (isAuth) {
      fetchConfig({ lobDetails, partyId });
    }
  }, [isAuth, lobDetails, partyDetails]);

  const {
    contents: { alertsForContext }
  } = notifications;

  if (isEDLJourney()) {
    return <EDLHeader />;
  }

  return (
    <React.Fragment>
      {isAuth && config && profile ? (
        <PostLoginHeader
          config={config}
          profile={profile}
          notifications={notifications}
          markNotificationRead={markRead}
          profileCompleteness={profileCompleteness}
          partyDetails={partyDetails}
        />
      ) : (
        <ABHeader flowName="dedicated internet" LeadProduct="ILL" LineOfBusiness="ILL" />
      )}
    </React.Fragment>
  );
};

export default AppHeader;
